import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import _ from 'lodash';
import { styles } from './InvoiceTemplate.styles';
import {
  renderDownloadDate,
  renderEmissionDate,
  renderKeyFacture,
  renderPeriodeFacturation,
  totalMontantDu,
  getServiceBilling,
  montantDuByService,
  getTitle
} from './InvoiceTemplate.services';

import InvoiceFeeItem from '../InvoiceFeeItem';
import { DRIVER, PAYMENT_TYPE_CONTRACT, SUITABLE_PAYMENT_TYPES } from '../../constants/dataConfig';
import {
  displayPriceFormat,
  isObjectNotEmpty,
  isIntegerNotNull,
  isStringNotNull
} from '../../utils/tools';
import { DISHOP_INFO } from '../../constants/dishopInfo';
import { getDateFormat } from '../../utils/suitableDate';
import { ORDER_REFUND } from '../../constants';

class InvoiceTemplate extends React.Component {
  state = {
    isDishopCreditor: false,
    emptyInvoice: false,
    serviceBilling: {}
  };

  componentDidMount() {
    getServiceBilling(this, this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { billings } = this.props;
    if (!_.isEqual(nextProps.billings, billings)) getServiceBilling(this, nextProps);
  }

  renderInvoiceHeader = props => {
    const {
      legal,
      year,
      billings,
      dateInfo,
      isNetworkChecked,
      creditorLegal,
      isDriverInvoice
    } = props;
    const { isDishopCreditor } = this.state;
    const creditor =
      isDishopCreditor && !isNetworkChecked && !isDriverInvoice ? DISHOP_INFO : creditorLegal;
    const { address = {}, companyName, email, fullRegistrationNumber } = creditor;
    const { address: debitorAddress = {}, companyName: debitorCompanyName = '' } = legal;
    return (
      <>
        <View style={styles.companies}>
          <View>
            <Text style={styles.nameUs}>{companyName}</Text>
            {isObjectNotEmpty(address) && (
              <>
                <Text style={styles.presdishop}>
                  {address.streetNumber} {address.street},
                </Text>
                <Text style={styles.presdishop}>
                  {address.postalCode}, {address.city},
                </Text>
                <Text style={styles.presdishop}>{address.country}</Text>
              </>
            )}
            <Text style={styles.presdishop}>{email}</Text>
            {isStringNotNull(fullRegistrationNumber) && (
              <Text style={styles.presdishop}>RCS - {fullRegistrationNumber}</Text>
            )}
          </View>

          <View style={styles.rightHeader}>
            <View style={styles.rightLegal}>
              <Text style={[styles.presdishop, styles.underlinedText, styles.textStyle]}>
                Facturé à:
              </Text>

              <Text style={styles.nameBuis}>{debitorCompanyName}</Text>
              {isObjectNotEmpty(debitorAddress) && (
                <>
                  <Text style={styles.presdishop}>
                    {`${debitorAddress.streetNumber} ${debitorAddress.street}`},
                  </Text>
                  <Text style={styles.presdishop}>
                    {debitorAddress.postalCode}, {debitorAddress.city},
                  </Text>
                  <Text style={styles.presdishop}>{debitorAddress.country}</Text>
                </>
              )}
            </View>
          </View>
        </View>
        <View style={[styles.ref, styles.alignementStyle]}>
          <Text style={styles.text}>
            <Text style={styles.underlinedText}>Référence de facture:</Text>{' '}
            {renderKeyFacture(this.props)}
          </Text>
          <Text style={styles.text}>
            <Text style={styles.underlinedText}>Date d'émission:</Text>{' '}
            {renderEmissionDate(dateInfo, year, isDriverInvoice)}
          </Text>
          {!isDriverInvoice && (
            <Text style={styles.text}>
              <Text style={styles.underlinedText}>Période de facturation:</Text>{' '}
              {renderPeriodeFacturation(dateInfo, year)}
            </Text>
          )}
          {isDriverInvoice && (
            <Text style={styles.text}>
              <Text style={styles.underlinedText}>Type de paiement:</Text>{' '}
              {SUITABLE_PAYMENT_TYPES[billings.paymentType]}
            </Text>
          )}
          <Text style={styles.text}>
            <Text style={styles.underlinedText}>Date de téléchargement:</Text>{' '}
            {renderDownloadDate()}
          </Text>
        </View>
      </>
    );
  };

  renderDeliveryDetails = () => {
    const { legal, billings = {} } = this.props;
    const { address = {} } = legal;
    const { orderNumber, dateOrder, delivery } = billings;
    const { address: deliveryAddress = {}, date } = delivery;
    const { streetNumber, street, postalCode, city } = deliveryAddress;
    return (
      <View style={styles.contract}>
        <View style={[styles.border, styles.titleContract]}>
          <Text style={(styles.titleTab, styles.titleTextContract)}>Détails de la livraison</Text>
        </View>
        <View style={styles.firstTabValue}>
          <View style={styles.leftPart}>
            <View style={styles.rowDetail}>
              <Text style={styles.titleTab}>Retrait:</Text>
              <Text style={styles.deliveryLabel}>{` ${getDateFormat(date, 'LT')} | ${
                address.streetNumber
              } ${address.street}, ${address.postalCode}, ${address.city}, ${
                address.country
              }`}</Text>
            </View>
            <View style={styles.rowDetail}>
              <Text style={styles.titleTab}>Livraison:</Text>
              <Text style={styles.deliveryLabel}>{` ${getDateFormat(dateOrder, 'LT')} | ${
                isObjectNotEmpty(deliveryAddress)
                  ? `${streetNumber} ${street}, ${postalCode ? `${postalCode}, ` : ''}${city}`
                  : '--'
              }`}</Text>
            </View>
          </View>
          <View style={styles.rightPart}>
            <View style={styles.rowDetail}>
              <Text style={styles.titleTab}>N° livraison:</Text>
              <Text style={styles.deliveryLabel}>{orderNumber}</Text>
            </View>
            <View style={styles.rowDetail}>
              <Text style={styles.titleTab}>Date de livraison:</Text>
              <Text style={styles.deliveryLabel}>{getDateFormat(dateOrder)}</Text>
            </View>
            <View style={styles.rowDetail}>
              <Text style={styles.titleTab}>Distance parcourue:</Text>
              <Text style={styles.deliveryLabel}>{delivery.distance} km</Text>
            </View>
          </View>
        </View>
      </View>
    );
  };

  renderInvoiceObject = (isBalanceInvoice = false, isDriverInvoice = false) => {
    return (
      <>
        <Text style={[styles.text, styles.ref]}>
          <Text style={styles.underlinedText}>Objet:</Text>{' '}
          {isBalanceInvoice
            ? 'Fournit les informations détaillées de votre modification de solde ainsi que le solde final de compte sur la \n période.'
            : isDriverInvoice
              ? 'Frais pour le service de livraison'
              : 'Frais pour l’ensemble des services liés à la commande en ligne'}
        </Text>
      </>
    );
  };

  renderDriverDuty = subjectToTVA => {
    return (
      <View style={[styles.obligationView, styles.topBorder]}>
        {!subjectToTVA && (
          <Text style={[styles.tvaText]}> [1] : TVA non applicable, art.293B du CGI.</Text>
        )}
        <Text>
          En tant que coursier professionnel indépendant, vous êtes tenu de respecter des
          obligations fiscales et sociales. En effet, les revenus que vous tirez des livraisons de
          marchandises réalisées par l'intermédiaire de la plateforme Dishop Fleet sont imposables
          et soumis à cotisations sociales. Vous devez donc déclarer vos revenus à l'administration
          fiscale ainsi qu'à l'URSSAF afin, ensuite, de payer l'impôt et les cotisations sociales.
          Vous trouverez, ci-dessous, des liens vers les sites des administrations permettant de
          vous conformer à vos obligations :
        </Text>
        <View style={styles.link}>
          <Text>
            • Sur les obligations fiscales : https://www.impots.gouv.fr/portail/node/10841
          </Text>
          <Text>
            • Sur les obligations sociales :
            http://www.securite-sociale.fr/Vos-droits-et-demarches-dans-le-cadre-des-activites-
            economiques-entre-particuliers-Article-87
          </Text>
          <Text>
            • Pour un résumé explicatif de ces obligations :
            proxy-pubminefi.diffusion.finances.gouv.fr/pub/document/18/22081.pdf
          </Text>
        </View>
      </View>
    );
  };

  renderFooter = () => {
    return (
      <Text style={[styles.bottomPage, styles.topBorder]}>
        Des questions ? Contactez Dishop à l'adresse contact@dishop.co ou contactez directement
        votre référent commercial
      </Text>
    );
  };

  render() {
    const { isNetworkChecked, isDriverInvoice } = this.props;
    const { serviceBilling, isDishopCreditor, accountBalance = {}, emptyInvoice } = this.state;
    const { totalCash, totalCb, total, totalStripe } = accountBalance;
    let subjectToTVA = false;
    return (
      <>
        {(isObjectNotEmpty(serviceBilling) || isDriverInvoice) && (
          <Document title={`Facture dishop ${renderKeyFacture(this.props)}`}>
            <Page style={styles.body}>
              <Text style={styles.title}>Facture</Text>
              {this.renderInvoiceHeader(this.props)}
              <View style={styles.positionTab}>
                {this.renderInvoiceObject(false, isDriverInvoice)}
                {isDriverInvoice && this.renderDeliveryDetails()}

                {_.map(serviceBilling, (serviceBillingItem, key) => {
                  let totalHt = 0;
                  let totalSumFees = 0;
                  return (
                    <>
                      {(key !== DRIVER && key !== ORDER_REFUND && serviceBillingItem.length > 0) ||
                      isDriverInvoice ? (
                          <View style={styles.contract} key={key} wrap={false}>
                            {!isDriverInvoice && (
                              <View style={[styles.border, styles.titleContract]}>
                                <Text style={(styles.titleTab, styles.titleTextContract)}>
                                  {getTitle(key, this)}
                                </Text>
                              </View>
                            )}

                            <View style={styles.firstTabValue}>
                              {/* LEFT PART - LABEL */}
                              <View style={[styles.border, styles.row, styles.leftPart]}>
                                <Text style={styles.titleTab}>
                                  {isDriverInvoice ? 'Détails de la facture' : 'Description'}
                                </Text>
                                <Text style={styles.titleTab}>Qté</Text>
                              </View>
                              {/* RIGHT PART - LABEL  */}
                              <View style={[styles.border, styles.row, styles.rightPart]}>
                                <Text style={styles.titleTab}>Prix unitaire</Text>
                                <Text style={styles.titleTab}>Montant</Text>
                              </View>
                            </View>
                            {_.map(serviceBillingItem, (servicePrice, i) => {
                              const { sumFee, subjectToVAT = false } = servicePrice;
                              subjectToTVA = subjectToVAT;
                              const subtotalHT =
                              key.includes(PAYMENT_TYPE_CONTRACT) || subjectToTVA ? sumFee / 1.2 : sumFee;
                              totalSumFees += sumFee;
                              totalHt +=
                              (key.includes(PAYMENT_TYPE_CONTRACT) || subjectToTVA) &&
                              Math.round(subtotalHT * 100) / 100;
                              return (
                                <InvoiceFeeItem
                                  key={i.toString()}
                                  serviceBillingItem={serviceBillingItem}
                                  servicePrice={servicePrice}
                                  isDriverInvoice={isDriverInvoice}
                                  serviceBillingItemKey={key}
                                  isDishopCreditor={isDishopCreditor}
                                  totalSumFees={totalSumFees}
                                  subtotalHT={subtotalHT}
                                />
                              );
                            })}
                            <View style={styles.positionRow}>
                              <View style={styles.leftPart} />
                              <View style={styles.rightPart}>
                                <View style={[styles.tableau]}>
                                  <Text style={styles.labelTab}>Total HT</Text>
                                  <Text style={styles.labelTab}>
                                    {displayPriceFormat(
                                      key.includes(PAYMENT_TYPE_CONTRACT) || subjectToTVA
                                        ? totalHt
                                        : totalSumFees
                                    )}
                                  </Text>
                                </View>
                                {/* LIGNE 4  */}
                                {!key.includes(PAYMENT_TYPE_CONTRACT)&& !subjectToTVA ? (
                                  <View style={[styles.tableau, styles.border]}>
                                    <Text style={styles.labelTab}>
                                    TVA (0 %) {`${isDriverInvoice ? '[1]' : ''}`}
                                    </Text>
                                    <Text style={styles.labelTab}>{displayPriceFormat(0)}</Text>
                                  </View>
                                ) : (
                                  <View style={[styles.tableau, styles.border]}>
                                    <Text style={styles.labelTab}>TVA (20 %)</Text>
                                    <Text style={styles.labelTab}>
                                      {displayPriceFormat(totalSumFees - totalHt)}
                                    </Text>
                                  </View>
                                )}

                                {/* LIGNE 5  */}
                                <View style={styles.tableau}>
                                  <Text style={styles.totalLabel}>{getTitle(key, this, true)}</Text>
                                  <Text style={styles.totalStyle}>
                                    {displayPriceFormat(totalSumFees)}
                                  </Text>
                                </View>
                              </View>
                            </View>
                          </View>
                        ) : null}
                    </>
                  );
                })}
                {isDriverInvoice && this.renderDriverDuty(subjectToTVA)}
              </View>
              {this.renderFooter()}
            </Page>
            {!emptyInvoice && !isDriverInvoice && (
              <Page style={styles.body} size="A4">
                <Text style={styles.title}>Résumé du solde</Text>
                <View style={styles.positionTab2}>
                  {this.renderInvoiceObject(true)}
                  <View style={styles.positionTabValue}>
                    {/* LABEL  */}
                    <View style={[styles.border, styles.row]}>
                      <Text style={styles.titleTab}>Description</Text>
                      <Text style={styles.titleTab}>Montant</Text>
                    </View>
                    <View style={[styles.tableau, styles.rowPosition]}>
                      <Text style={styles.labelTab}>Volume transitant TOTAL (TTC)</Text>
                      <Text style={styles.labelTab}>{displayPriceFormat(total)}</Text>
                    </View>
                    {!isNetworkChecked && (
                      <>
                        <View style={[styles.tableau, styles.rowPosition]}>
                          <Text style={styles.labelTab}>
                            Volume transitant via Paiement en ligne (TTC)
                          </Text>
                          <Text style={styles.labelTab}>{displayPriceFormat(totalStripe)}</Text>
                        </View>
                        {isIntegerNotNull(totalCb) && (
                          <View style={[styles.tableau, styles.rowPosition]}>
                            <Text style={styles.labelTab}>
                              Volume transitant via Terminal (TTC)
                            </Text>
                            <Text style={styles.labelTab}>{displayPriceFormat(totalCb)}</Text>
                          </View>
                        )}
                        {isIntegerNotNull(totalCash) && (
                          <View style={[styles.tableau, styles.rowPosition]}>
                            <Text style={styles.labelTab}>Volume transitant en Espèce (TTC)</Text>
                            <Text style={styles.labelTab}>{displayPriceFormat(totalCash)}</Text>
                          </View>
                        )}
                      </>
                    )}
                    <View style={styles.border} />
                    {serviceBilling &&
                      _.map(serviceBilling, (billing, key) => {
                        return (
                          billing.length > 0 && (
                            <View style={[styles.tableau, styles.rowPosition]} key={key}>
                              <Text style={styles.labelTab}> {getTitle(key, this, true)}</Text>
                              <Text style={styles.labelTab}>
                                {displayPriceFormat(montantDuByService(billing))}
                              </Text>
                            </View>
                          )
                        );
                      })}
                    <View style={styles.border} />
                    <View style={[styles.tableau, styles.rowPosition]}>
                      <View>
                        <Text style={styles.labelTab}>Solde de compte</Text>
                        <Text style={[styles.underLabel, styles.rowPosition]}>
                          Volume transitant {!isNetworkChecked ? 'via paiement en ligne' : ''} -
                          Montants dûs
                        </Text>
                      </View>
                      <View>
                        <Text style={styles.labelTab}>
                          {displayPriceFormat(
                            (isNetworkChecked ? total : totalStripe) -
                              totalMontantDu(serviceBilling)
                          )}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
                {this.renderFooter()}
              </Page>
            )}
          </Document>
        )}
      </>
    );
  }
}

export default InvoiceTemplate;
